import React, { useState } from "react";
import { format } from "date-fns";

// ICON IMPORTS
import picked from "../../assets/Picked.svg";
import pickedGreen from "../../assets/Picked-green.svg";

import orderOnBus from "../../assets/Order-on-the-Bus.svg";
import orderOnBusGreen from "../../assets/Order-on-the-Bus-green.svg";

import busPickup from "../../assets/Bus-Pickup.svg";
import busPickupGreen from "../../assets/Bus-Pickup-green.svg";

import delivered from "../../assets/Delivered.svg";
import deliveredGreen from "../../assets/Delivered-green.svg";

// Add packed status icons
import packed from "../../assets/Tracking/packed.svg";
import yetToPack from "../../assets/Tracking/yettopack.svg";

const TrackingModal = ({ showModal, setShowModal, trackingInfo }) => {
  const [openAccordion, setOpenAccordion] = useState(0);
  const orderData = trackingInfo;

  const toggleAccordion = (index) => {
    setOpenAccordion((prev) => (prev === index ? -1 : index));
  };

  const formatDate = (dateStr) => {
    return format(new Date(dateStr), "dd MMM yyyy, hh:mm a");
  };

  const STATUS_STEPS = [
    {
      key: "packed",
      label: "packed",
      icon: picked,
      activeIcon: pickedGreen,
    },
    {
      key: "picked",
      label: "picked",
      icon: picked,
      activeIcon: pickedGreen,
    },
    {
      key: "order-on-the-bus",
      label: "order-on-the-bus",
      icon: orderOnBus,
      activeIcon: orderOnBusGreen,
    },
    {
      key: "bus-pickup",
      label: "bus-pickup",
      icon: busPickup,
      activeIcon: busPickupGreen,
    },
    {
      key: "delivered",
      label: "delivered",
      icon: delivered,
      activeIcon: deliveredGreen,
    },
  ];

  return (
    <>
      {/* <button
        className="bg-blue-600 text-white px-4 py-2 rounded"
        onClick={() => setShowModal(true)}
      >
        View Order Tracking
      </button> */}

      {showModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white max-w-4xl w-full rounded-lg shadow-lg p-6 overflow-y-auto max-h-[90vh]">
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <div>
                <h2 className="text-xl font-bold text-[#003F6B] mb-1">
                  Order No: {orderData?.orderNo || "N/A"}
                </h2>
                {orderData?.status && (
                  <h2 className="text-base font-bold text-green-600">
                    Status: {orderData.status}
                  </h2>
                )}
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="text-2xl text-gray-500 hover:text-red-600"
              >
                &times;
              </button>
            </div>

            {/* Error Message Display */}
            {orderData?.message && (
              <div className="w-full text-center py-16 text-lg font-semibold text-red-600 bg-red-50 rounded-lg border border-red-200">
                <p>{orderData.message}</p>
              </div>
            )}

            {/* If Consignments Not Created */}
            {!orderData?.message && orderData?.consignments === "Consignments Not Created Yet" ? (
              <div className="w-full text-center py-16 text-lg font-semibold text-gray-700">
                <p>Consignments have not been created yet for this order.</p>
              </div>
            ) : (
              <>
                {orderData?.consignments && Array.isArray(orderData.consignments) && orderData.consignments.map((consign, index) => (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg mb-4 shadow-sm"
                  >
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="w-full text-left px-6 py-2 bg-gray-100 hover:bg-gray-200 rounded-t-lg flex justify-between items-center"
                    >
                      <span className="font-semibold text-gray-800">
                        Consignment ID: {consign.id}
                      </span>
                      <span className="text-gray-500 text-xl">
                        {openAccordion === index ? "−" : "+"}
                      </span>
                    </button>

                    {/* Accordion Content */}
                    {openAccordion === index && (
                      <div className="p-6 bg-white">
                        {/* Status Tracker with Icons */}
                        <div className="flex justify-between items-center mb-6">
                          {STATUS_STEPS.map((step, idx) => {
                            // Improved status matching logic
                            const isReached = consign.status.some((s) => {
                              const stepKey = step.key.toLowerCase();
                              const statusKey = s.status.toLowerCase();
                              
                              // Handle special cases for status matching
                              if (stepKey === "packed" && statusKey === "packed") return true;
                              if (stepKey === "picked" && statusKey === "picked") return true;
                              if (stepKey === "order-on-the-bus" && statusKey.includes("order") && statusKey.includes("bus")) return true;
                              if (stepKey === "bus-pickup" && statusKey.includes("bus") && statusKey.includes("pickup")) return true;
                              if (stepKey === "delivered" && statusKey === "delivered") return true;
                              
                              // Fallback to includes for other cases
                              return stepKey.includes(statusKey) || statusKey.includes(stepKey);
                            });
                            
                            // If order status is DELIVERED, show all steps as green
                            const shouldShowGreen = orderData.status === "DELIVERED" || isReached;
                            return (
                              <div
                                key={step.key}
                                className="flex-1 flex items-center"
                              >
                                <div className="flex flex-col items-center text-center">
                                  <img
                                    src={
                                      shouldShowGreen
                                        ? step.activeIcon
                                        : step.icon
                                    }
                                    alt={step.label}
                                    className="w-10 h-10 mb-1"
                                  />
                                  <span
                                    className={`text-xs font-medium ${
                                      shouldShowGreen
                                        ? "text-green-600"
                                        : "text-gray-400"
                                    }`}
                                  >
                                    {step.label}
                                  </span>
                                </div>
                                {idx < STATUS_STEPS.length - 1 && (
                                  <div className={`flex-1 h-px mx-2 ${
                                    shouldShowGreen ? "bg-green-300" : "bg-gray-300"
                                  }`}></div>
                                )}
                              </div>
                            );
                          })}
                        </div>

                        {/* Status History */}
                     
                        {/* Item Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-sm border border-collapse border-gray-300">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="p-2 border border-gray-300 text-left">
                                  Item Name
                                </th>
                                <th className="p-2 border border-gray-300 text-center">
                                  Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {consign.itemDetails.map((item, idx) => (
                                <tr key={idx}>
                                  <td className="p-2 border border-gray-300">
                                    {item.itemDetails}
                                  </td>
                                  <td className="p-2 border border-gray-300 text-center">
                                    {item.quantity}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TrackingModal;
